import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

// Initialize with your Measurement ID from the Google Ads/Analytics dashboard
ReactGA.initialize("G-2J60PXF8W0"); 

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // This sends the current path to Google whenever the route changes
    ReactGA.send({ 
      hitType: "pageview", 
      page: location.pathname + location.search 
    });
    
    // console.log(`Mapsd to: ${location.pathname}`); // Optional: for debugging
  }, [location]);

  return null; // This component doesn't render anything UI-wise
};

export default Analytics;


